<template>
  <div class="subpage">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in this.driveControl.text.pageNavbar"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page :options="options" id="fullpage" ref="fullpage">
      <div
        class="subpage-header section fp-auto-height-responsive"
        data-anchor="drive-control"
      >
        <div class="section-container">
          <div class="section-wrapper text-right">
            <h2
              class="uppercase header"
              data-aos="text-focus-in"
              data-aos-duration="500"
            >
              Większa
              <span>Kontrola</span>
              w czasie jazdy
            </h2>
            <p
              class="description"
              data-aos="text-focus-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.headerDesc }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="text-with-video section fp-auto-height-responsive"
        data-anchor="S-AWC"
      >
        <div class="section-container">
          <div class="section-text">
            <div class="section-wrapper">
              <h5
                class="uppercase header-sub"
                data-aos="fade-down"
                data-aos-duration="500"
              >
                {{ this.driveControl.text.textWitVideoSubHeader }}
              </h5>
              <h2
                class="uppercase header"
                data-aos="zoom-in"
                data-aos-delay="150"
                data-aos-duration="500"
              >
                {{ this.driveControl.text.textWitVideoHeader }}
              </h2>
              <p
                class="description"
                data-aos="zoom-in"
                data-aos-delay="300"
                data-aos-duration="500"
              >
                {{ this.driveControl.text.textWitVideoDesc }}
              </p>
              <!--<v-btn
                :class="'mmc-blue background'"
                class="gallery"
                data-aos="text-focus-in"
                data-aos-delay="450"
                data-aos-duration="1000"
                data-selector=".movie"
                v-ripple="{ class: 'ripple-blue' }"
              >
                <span
                  class="movie"
                  data-src="https://www.youtube.com/watch?v=SlLjksmjnqk"
                ></span>
                <i class="fas fa-play"></i>
                {{ this.driveControl.text.textWitVideoButton }}
              </v-btn>-->
              <div
                class="image-background"
                data-aos="zoom-in"
                data-aos-delay="600"
                data-aos-duration="1000"
              >
                <img
                  :src="require('@/assets/images/drivecontrol/sawc.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="section-video">
            <div class="section-wrapper">
              <video-background
                :src="require('@/assets/videos/sawc.mp4')"
                :poster="
                  require('@/assets/images/drivecontrol/sawc-background.jpg')
                "
                :autoplay="false"
                :loop="false"
                @ready="pauseOnStart('sawc')"
                @ended="endedVideo('sawc')"
                ref="sawc"
                data-ref="sawc"
              ></video-background>
            </div>
          </div>
        </div>
      </div>
      <div
        class="section-background section fp-auto-height-responsive"
        data-anchor="drive-mode"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.driveModeSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.driveModeHeader }}
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              W zależności od warunków na drodze możesz wybrać jeden z czterech
              trybów jazdy: NORMAL (drogi asfaltowe), TARMAC (kręte drogi
              asfaltowe), GRAVEL (nawierzchnie luźne np. szuter), SNOW (drogi
              pokryte śniegiem).
            </p>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="300"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=YXIxB4c4rVY"
              ></span>
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=RaOeKpgpNKM"
              ></span>
              <i class="fas fa-play"></i>
              {{ this.driveControl.text.headerButton }}
            </v-btn>-->
          </div>
        </div>
      </div>
      <div
        class="text-two-images section fp-auto-height-responsive"
        data-anchor="more"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedSubHeader }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedHeader }}
            </h2>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedEasy }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedEasyDesc }}
            </p>
            <h3
              class="header-pref text-uppercase"
              data-aos="zoom-in"
              data-aos-delay="600"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedMode }}
            </h3>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="750"
              data-aos-duration="500"
            >
              {{ this.driveControl.text.advancedModeDesc }}
            </p>
          </div>
        </div>
        <div class="side-gallery gallery" data-selector="div">
          <div
            :data-aos-delay="index * 150"
            :data-src="require('@/assets/images/drivecontrol/' + image)"
            :key="index"
            :style="{
              backgroundImage:
                'url(' + require('@/assets/images/drivecontrol/' + image) + ')'
            }"
            data-aos="zoom-in"
            data-aos-duration="500"
            v-for="(image, index) of this.driveControl.text.advancedImages"
          >
            <i class="fas fa-image"></i>
          </div>
        </div>
      </div>
      <div
        class="footer section fp-auto-height-responsive"
        data-anchor="features"
      >
        <div class="section-container">
          <swiper
            :options="driveControl.mainSlider"
            class="swiper slider-flex"
            ref="mainSlider"
            @slideChange="updatePaginationIndex"
          >
            <swiper-slide
              :key="slider.header"
              class="slider-item"
              v-for="slider in this.driveControl.text.footerSlider"
            >
              <div
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/drivecontrol/' +
                      slider.background) +
                    ')'
                }"
                class="background"
              ></div>
              <div class="slider-text">
                <div class="text-wrapper">
                  <h3 class="header text-uppercase">{{ slider.header }}</h3>
                  <p>{{ slider.description }}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="arrows">
            <i class="fas fa-angle-left" @click="prevSlide"></i>
            <i class="fas fa-angle-right" @click="nextSlide"></i>
          </div>
          <div class="dots">
            <div
              class="dot"
              :key="index"
              :class="
                index === driveControl.mainSliderActiveIndex
                  ? 'current-slide'
                  : ''
              "
              @click="goToPage(index)"
              v-for="(dot, index) in this.driveControl.text.footerSlider"
            ></div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import VideoBackground from "vue-responsive-video-background-player";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "DriveControl",
  data: function() {
    return {
      options: {
        licenseKey: "3AAF9650-2EB641C5-91E1ED66-B5D30F2B",
        scrollBar: true,
        verticalCentered: false,
        menu: ".page-navbar ul",
        responsiveWidth: 767,
        responsiveHeight: 650,
        scrollingSpeed: 0,
        loopTop: true,
        loopBottom: true,
        paddingTop: 0,
        paddingBottom: 0,
        onLeave: this.onLeave
      }
    };
  },
  components: {
    VideoBackground,
    swiper,
    swiperSlide,
    FullPage,
    Footer
  },
  computed: {
    ...mapGetters({
      driveControl: "driveControl",
      header: "header"
    })
  },
  methods: {
    ...mapMutations({
      changeSliderPage: "changeSliderPage"
    }),
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".subpage-header"
      ).offsetHeight;
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    prevSlide() {
      this.$refs.mainSlider.swiper.slidePrev();
      this.updatePaginationIndex();
    },
    nextSlide() {
      this.$refs.mainSlider.swiper.slideNext();
      this.updatePaginationIndex();
    },
    goToPage(value) {
      this.$refs.mainSlider.swiper.slideToLoop(value);
      this.updatePaginationIndex();
    },
    updatePaginationIndex() {
      this.changeSliderPage(this.$refs.mainSlider.swiper.realIndex);
    },
    pauseOnStart(name) {
      const activeSlide = document.querySelector(
        ".fp-section.active .vue-responsive-videobg"
      );

      if (activeSlide !== null) {
        if (name === activeSlide.getAttribute("data-ref"))
          this.$refs[name].player.play();
      }
    },
    endedVideo(name) {
      this.$refs[name].player.play();
    },
    onLeave(origin, destination, direction) {
      if (
        destination.item.classList.contains("movie-section") ||
        destination.item.classList.contains("text-with-video")
      ) {
        const ref = destination.item
          .querySelector(".vue-responsive-videobg")
          .getAttribute("data-ref");
        this.$refs[ref].player.play();
      }
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");

    galleries.forEach(e => {
      window.lightGallery(e, {
        selector: e.getAttribute("data-selector"),
        download: false,
        autoplay: false,
        videoMaxWidth: "1920px"
      });
    });

    body.classList.add("no-overflow");

    this.$refs.mainSlider.swiper.update();

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHomeHeaderSize);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/mixins";
@import "src/styles/page-navbar";
@import "src/styles/footer-subpage";
@import "src/styles/text-two-images";
@import "src/styles/section-background";
@import "src/styles/text-with-video";

.subpage-header {
  @include set-background(no-repeat, center center, cover);
  background-image: url("../assets/images/drivecontrol/header-background.jpg");
  padding: var(--page-offset);

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;
    padding: var(--page-offset);
    align-content: center;
    justify-content: flex-end;

    .section-wrapper {
      width: 50%;

      @media screen and (max-width: $screen-md) {
        width: 75%;
      }

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header {
        span {
          color: $mmc-blue;
        }
      }
    }
  }
}
</style>
